// extracted by mini-css-extract-plugin
module.exports = {"tagsList":"tags-antd_tagsList__3LLaw","tagItem":"tags-antd_tagItem__2jeIS"};